<template>
    <div>
        <div v-if="currencyPlaceholder" class="input-wrapper">
            <div class="currency-box">
                <!-- <img class="img-fluid" src="~assets/images/icons/currency-pound.svg" alt="Currency Sign Pound"/> -->
                <svg version="1.2" baseProfile="tiny-ps" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 805 805" width="512" height="512"><title>Currency Sign Pound</title><path style="fill: #b6b6b6;" d="M409.5 34.13C402.9 34.6 392.1 35.9 385.5 37.01C378.9 38.13 368.1 40.41 361.5 42.09C354.9 43.77 345.23 46.72 340 48.66C334.77 50.59 324.65 55.02 317.5 58.5C310.35 61.99 299.77 67.96 294 71.78C288.23 75.59 279.23 82.31 274 86.71C268.77 91.1 261.34 98.26 257.48 102.6C253.61 106.95 248.84 112.53 246.87 115C244.89 117.47 240.65 123.55 237.43 128.5C234.22 133.45 229.03 142.9 225.9 149.5C222.77 156.1 218.62 166.45 216.68 172.5C214.73 178.55 212.23 188 211.12 193.5C210.01 199 208.62 208.22 208.04 214C207.43 220.07 206.99 249.29 206.99 283.25L207 342L155.35 342.5C148.82 346.8 146.13 349.74 145 352C143.11 355.78 143 357.98 143.02 392.25C143.04 426.24 143.17 428.76 145.02 432.75C146.25 435.39 148.58 438.04 151.17 439.75L155.35 442.5L207 443L207 650L142.35 650.5C136.13 654.55 133.57 657.47 132.26 660.06C130.07 664.41 130.03 665.22 130.04 700.5C130.04 733.07 130.22 736.88 131.85 740.5C132.84 742.7 135.08 745.74 136.83 747.25C138.76 748.92 142.05 750.4 145.25 751.02C148.74 751.69 230.59 751.94 389 751.77L627.5 751.5C633.7 748.18 636.26 746.38 637.19 745.36C638.12 744.34 639.58 741.81 640.44 739.75C641.81 736.45 642 725.57 641.99 648.97C641.98 578.79 641.72 561.31 640.65 558.72C639.92 556.95 637.67 554.04 635.66 552.25C633.65 550.46 630.31 548.52 628.25 547.94C625.81 547.25 610.68 546.99 585 547.19C547.82 547.48 545.27 547.62 541.57 549.5C539.41 550.6 536.48 553.27 535.07 555.43L532.5 559.35L531.5 647.5L334.5 647.5L334.5 443.5L475.65 442.5C481.87 438.45 484.43 435.53 485.74 432.94C487.93 428.59 487.97 427.77 487.99 392.25C488 360.81 487.78 355.57 486.38 352.75C485.49 350.96 484.03 348.67 483.13 347.65C482.23 346.63 480.15 345.05 478.5 344.15C475.82 342.68 467.96 342.45 405 342L334.5 341.5C334.5 233.98 334.68 227.68 336.33 220C337.34 215.32 339.46 208.13 341.05 204C342.64 199.88 346.09 193.24 348.72 189.26C351.35 185.27 356.42 179.03 360 175.39C363.58 171.74 368.98 167.08 372 165.02C375.02 162.96 380.31 159.86 383.75 158.14C387.19 156.41 393.26 153.92 397.25 152.59C401.24 151.27 408.77 149.46 414 148.58C419.23 147.71 428.11 146.99 433.75 146.99C439.51 147 449.15 147.89 455.75 149.03C462.21 150.15 472.9 152.86 479.5 155.05C486.1 157.24 497.35 161.94 504.5 165.49C511.65 169.03 520.88 173.8 525 176.07C531.95 179.91 532.9 180.16 538 179.62C541.33 179.26 544.76 178.13 546.7 176.76C548.46 175.52 560.56 161.22 573.59 145C586.63 128.78 598.12 113.7 599.12 111.5C600.13 109.3 600.96 105.93 600.96 104C600.97 102.07 599.97 98.5 598.74 96.06C597.32 93.24 594.48 90.14 591 87.59C587.98 85.37 581.23 80.71 576 77.22C570.77 73.73 558.4 66.88 548.5 62C538.6 57.12 526 51.48 520.5 49.46C515 47.44 505.1 44.31 498.5 42.5C491.9 40.69 480.88 38.26 474 37.1C467.13 35.94 454.98 34.55 447 34.01C439.02 33.47 430.02 33.09 427 33.16C423.98 33.23 416.1 33.67 409.5 34.13Z" /></svg>
            </div>
            <input
                class="form-control calc-form-control"
                type="number"
                :min="min"
                :max="max"
                ref="currencyInput"
                @input="handleInput"
                @keyup="formatInputValue"
                :placeholder="placeholder"
            >
        </div>
        <input
            v-else
            class="form-control calc-form-control"
            type="number"
            :min="min"
            :max="max"
            @input="handleInput"
            :placeholder="placeholder"
        >
    </div>
</template>

<script>
export default {
    props: {
        value: {},
        max: {
            type: Number
        },
        min: {
            type: Number,
            default: 0
        },
        currencyPlaceholder: {
            type: Boolean,
            default: false
        },
        placeholder: String
    },
    methods: {
        handleInput(e) {
            this.$emit('input', parseInt(e.target.value))
        },
        formatCurrencyInput(price) {
            //eslint-disable-next-line
            price.replace(/[\D\s\._\-]+/g, "");
            price = price ? parseInt( price, 10 ) : "";

            // console.log(price)
        
            if ( Number.isNaN(price) ) {
                return price = "";
            }

            // console.log(price.toLocaleString( "en-GB" ));

            // console.log(new Intl.NumberFormat('en-GB').format(price));

            return price
        },
        formatInputValue() {
            this.$refs.currencyInput.value = this.formatCurrencyInput(this.$refs.currencyInput.value)  

        }      
    }
}
</script>

<style lang="scss" scoped>
.input-wrapper {
    position: relative;
    
    .currency-box {
        position: absolute;
        top: 0px;
        left: 0px;
        height: 34px;
        width: 32px;
        z-index: 1;
        padding: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-right: 1px solid $grey-darker;
    }

    input.form-control.calc-form-control {
        padding-left: 44px;
    }
}
</style>